/**
 * The desktop shell's bridge (apps/desktop/src/preload.ts), present only inside the Windows till.
 * In a browser it is undefined, and every desktop-only control stays hidden.
 */

export interface DesktopBridge {
  info(): Promise<{ version: string; dataDir: string; url: string | null; settings: DesktopSettings }>;
  /** Silent print of the current page (the receipt) to the chosen printer. */
  print(): Promise<{ ok: boolean; error?: string }>;
  printers(): Promise<string[]>;
  saveSettings(patch: Partial<DesktopSettings>): Promise<DesktopSettings>;
  openDataFolder(): Promise<string>;
  backupNow(): Promise<{ path: string; bytes: number; at: string }>;
  listBackups(): Promise<{ name: string; path: string; bytes: number; at: string }[]>;
  restore(path: string): Promise<{ restored: boolean; replacedCopy?: string }>;
}

export interface DesktopSettings {
  receiptPrinter: string;
  silentPrint: boolean;
  autoStart: boolean;
  backupDir: string | null;
}

export function desktopBridge(): DesktopBridge | null {
  return typeof window !== 'undefined' ? ((window as unknown as { desktop?: DesktopBridge }).desktop ?? null) : null;
}
